import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MASCOTS, auraStyle } from "../data/gameData";
import { useProfile } from "../context/ProfileContext";

export default function MascotCoach({ mascotId = "lumi", message, color }) {
  const { profile } = useProfile();
  const mascot = MASCOTS[mascotId] || MASCOTS.lumi;
  const accent = color || mascot.color;
  const aura = auraStyle(profile?.equipped?.aura);
  return (
    <div className="flex items-end gap-2" data-testid="mascot-coach">
      <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden shrink-0 border-2 floaty"
           style={{ borderColor: accent, ...aura }}>
        <img src={mascot.img} alt={mascot.name} className="w-full h-full object-cover" />
      </div>
      <AnimatePresence mode="wait">
        {message && (
          <motion.div
            key={message}
            initial={{ opacity: 0, y: 8, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ type: "spring", stiffness: 300, damping: 22 }}
            className="relative bg-white text-[#12091F] rounded-2xl rounded-bl-sm px-3.5 py-2 text-sm font-semibold shadow-lg max-w-[220px]"
            data-testid="mascot-message">
            {message}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
